import axiosClient from "api/apiClient";

export const APIPostGrades = (data: object) => {
  return axiosClient.post("/tests/grades", data);
};

export const APIPostGradesCustomTest = (data: object) => {
  return axiosClient.post("/personal-items-subcategories/grades", data);
};

export const APIPostCategories = (data: object) => {
    return axiosClient.post("/tests/categories", data);
  };

  export const APICreateTest = (data: object) => {
    return axiosClient.post("/tests/create", data);
  };

  export const APIShareTestLink = (data: object) => {
    return axiosClient.post("/tests/share-link", data);
  }